module.exports = require("./pa-Arab");